const timeFormat = function(dateVal) {
	let time = new Date(dateVal*1000);
	let year = time.getFullYear();
	let month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1);
	let day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
	return year + "/" + month + "/" + day;
}
const timeFormatString = function(dateVal) {
	let time = new Date(dateVal*1000);
	let year = time.getFullYear();
	let month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1);
	let day = time.getDate() > 9 ? time.getDate() : "0" + time.getDate();
	return year + "年" + month + "月" + day + "日";
}

module.exports = {
	timeFormat,
	timeFormatString
}



// WEBPACK FOOTER //
// ./src/utils/filter.js